(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Adaptive header color: white over dark sections, black over light sections
  (function () {
    const hw = document.querySelector('.header-wrapper');
    if (!hw) return;

    function lum(r, g, b) { return 0.299 * r + 0.587 * g + 0.114 * b; }

    // Returns true (dark) / false (light) / null (no info on this element alone)
    function checkEl(el) {
      const s = getComputedStyle(el);

      // background-color and background-image are NOT inherited in CSS,
      // so they reliably reflect what is set directly on this element.
      // We skip --color-background because Shopify applies it to :root (first scheme),
      // making it inherited by every element and causing false positives.

      // 1. Solid background-color
      const bg = s.backgroundColor;
      if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') {
        const m = bg.match(/\d+/g);
        if (m && m.length >= 3) return lum(+m[0], +m[1], +m[2]) < 140;
      }

      // 2. CSS gradient or background-image (e.g. radial-gradient on .bryda-leg-hero)
      if (s.backgroundImage !== 'none') return true;

      return null;
    }

    // Scans the section and all its descendants for any background signal
    function sectionIsDark(section) {
      // Explicit override: any element with data-header-dark marks the section as dark
      if (section.querySelector('[data-header-dark]')) return true;

      // Built-in image banner hero
      if (section.querySelector('.banner__media')) return true;

      // Scan all descendants for a solid or gradient background
      const els = [section, ...section.querySelectorAll('*')];
      for (let i = 0; i < Math.min(els.length, 60); i++) {
        const r = checkEl(els[i]);
        if (r !== null) return r;
      }

      return false;
    }

    function update() {
      const h = hw.offsetHeight || 64;

      // Find which section the header currently overlaps (last section whose top ≤ header bottom)
      const sections = document.querySelectorAll('.shopify-section');
      if (!sections.length) return;

      let active = sections[0];
      for (const s of sections) {
        if (s.getBoundingClientRect().top <= h) active = s;
      }

      const dark = sectionIsDark(active);
      hw.classList.toggle('header--over-dark', dark);
      hw.classList.toggle('header--over-light', !dark);
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    requestAnimationFrame(update);
  })();

  } catch(e) { console.error(e); }
})();
})();
